<template>
  <div>
    <div v-if="facility=='app'" class="app">
      <!-- <Mzszp/> -->
    </div>
    <div v-else class="pc_exhibit">
      <Zp/>
    </div>
  </div>
</template>

<script>
// import Mzszp from "../exhibitor/app/zszp";
import Zp from "./pc/index";
export default {
  components:{
    // Mzszp,
    Zp,
  },
  data(){
    return{
      facility:""
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  methods:{
    
  }
}
</script>

<style scoped>
  .pc_exhibit{
    background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/exhibitorBg.jpg");
    background-repeat: no-repeat;
    background-size: 100%;
    background-color: #f2f2f2;
  }
</style>